import { borderRadius, spacing } from "./settingsListDesign";
import { HolderOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { Checkbox } from "../ui";
import React from "react";
import { dndTransformToCss } from "./dndTransform";

const DRAGGING_OPACITY = 0.5;

export type SortableColumnItemProps = {
  id: string;
  label: React.ReactNode;
  visible: boolean;
  onToggle: () => void;
};

/**
 * Einzelner sortierbarer Eintrag (Drag-Handle + Checkbox + Label) für Spalteneditor-Modals.
 * Verwendet in useProTableColumnEditor.
 */
export function SortableColumnItem({ id, label, visible, onToggle }: SortableColumnItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style: React.CSSProperties = {
    transform: dndTransformToCss(transform),
    transition,
    opacity: isDragging ? DRAGGING_OPACITY : 1,
    marginBottom: spacing.sm,
    padding: `${spacing.sm}px ${spacing.md}px`,
    background: "var(--ant-color-bg-container)",
    border: "1px solid var(--ant-color-border)",
    borderRadius: borderRadius.control,
    display: "flex",
    alignItems: "center",
    gap: spacing.md,
  };

  const handleCheckboxClick = (e: React.MouseEvent | { stopPropagation: () => void }) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div {...attributes} {...listeners} style={{ cursor: "move", display: "flex", alignItems: "center" }}>
        <HolderOutlined style={{ color: "var(--ant-color-text-secondary)" }} />
      </div>
      <Checkbox checked={visible} onChange={(e) => handleCheckboxClick(e.nativeEvent)} onClick={handleCheckboxClick}>
        {label}
      </Checkbox>
    </div>
  );
}
